export const LogoMark = ({ size = 36, className = "" }) => (
  <img src="/logo.png" alt="The Obsidian Vault monogram" width={size} height={size}
    className={`object-contain ${className}`} data-testid="logo-mark" />
);
